<template>
  <transition
    name="modal"
    appear
  >
    <div
      :class="cssClass"
      @keyup.esc="handleButton('close')"
    >
      <owal-panel
        v-bind="this.$props"
        @button-click="handleButton"
      >
        <slot v-if="!content" />
      </owal-panel>
    </div>
  </transition>
</template>

<script>

import OwalPanel from './OwalPanel'

export default {
  name: 'OwalModalPanel',
  components: {
    OwalPanel,
  },
  extends: OwalPanel,
  props: {
    presentationStyle: {
      type: String,
      default: 'alert',
      validation: function (value) {
        const values = ['alert', 'form']

        if (!values.includes(value)) {
          console.log(`OwalModalPanel.vue: The value you supplied for prop called style is invalid. Please use one of the following: ${values}. You passed in ${value}`)
          return false
        }
        return true
      },
    },
  },
  computed: {
    cssClass: function () {
      return `owal modal ${this.presentationStyle} style`
    },
  },
  methods: {
    handleButton (identifier) {
      this.$emit('button-click', identifier)
    },
  },
}
</script>

<style scoped>
.owal.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  z-index: 800;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  /* Modal Overlay */
  /* background-image: url('../assets/img/gradient.png'); */
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}

.owal.panel.active.window,
.owal.panel.inactive.window {
  z-index: 801;
}

/* Desktop */
@media only screen and (min-width: 768px) {
  .owal.modal.form.style .owal.panel.active.window,
  .owal.modal.form.style .owal.panel.inactive.window {
    width: 61rem;
    max-height: 80%;
  }

  .owal.modal.alert.style .owal.panel.active.window,
  .owal.modal.alert.style .owal.panel.inactive.window {
    width: 40rem;
    max-height: 15rem;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1.2);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
}

/* Mobile */
@media only screen and (max-width: 768px) {
  @keyframes bounce-in {
    0% {
      transform: translateY(100%)
    }
    100% {
      transform: translateY(0);
    }
  }
}

/* Animations */

.modal-enter-active {
  animation-name: bounce-in;
  animation-duration: 300ms;
}
.modal-leave-active {
  animation-name: bounce-in;
  animation-direction: reverse;
  animation-duration: 300ms;
}

</style>
